module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-wrapper site-page--not-found"
  }, [_c('div', {
    staticClass: "site-content__wrapper"
  }, [_c('div', {
    staticClass: "site-content"
  }, [_c('h2', {
    staticClass: "not-found-title"
  }, [_vm._v("404")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('i-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回上一页")]), _vm._v(" "), _c('i-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Home'
        })
      }
    }
  }, [_vm._v("进入首页")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "not-found-desc"
  }, [_vm._v("抱歉！您访问的页面"), _c('em', [_vm._v("失联")]), _vm._v("啦 ...")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d60ead9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404/index.vue
// module id = 922
// module chunks = 1